import { Component, inject } from '@angular/core';
import { UwIcon } from '../icon/uw-icon';
import { LoaderService } from '../../../core/services/loader.service';

@Component({
  selector: 'uw-loader-host',
  standalone: true,
  imports: [UwIcon],
  template: `
    @if (loader.isLoading()) {
      <div class="pointer-events-none fixed inset-0 z-modal flex items-center justify-center bg-black/20 px-4">
        <div class="pointer-events-auto flex min-w-[18rem] items-center gap-3 rounded-2xl border border-line bg-surface-elevated px-4 py-3 shadow-lg backdrop-blur">
          <div class="flex h-10 w-10 items-center justify-center rounded-full bg-ai-soft text-ai">
            <uw-icon name="refresh" [size]="18" class="animate-spin" />
          </div>
          <div class="min-w-0">
            <p class="text-[12.5px] font-semibold text-primary">{{ loader.message() }}</p>
            <p class="text-[11px] text-text-muted">Please wait while we load the latest data.</p>
          </div>
        </div>
      </div>
    }
  `,
})
export class UwLoaderHost {
  protected readonly loader = inject(LoaderService);
}
